import React from "react";
import "./about.scss";
import img2 from "../../assets/about/unsplash__M6gy9oHgII.png";
import img3 from "../../assets/about/img1.jpg";
import img1 from "../../assets/about/img2.jpg";

const about = () => {
  return (
    <div className="container about-outer">
      <div className="row first-div-done">
        <p className="text-center first-div ">ABOUT US</p>
        <p className="text-center second-div">BEST PRODUCTS FOR YOU</p>
      </div>
      <div className="row second-container mt-5">
        <h4 className="">Where Style Meets Substance</h4>
        <p className="col-12 ">
          RAER isn’t just a brand—it’s a statement. We craft shirts that go
          beyond the ordinary, blending timeless elegance with a distinct edge.
          For the man who refuses to be average, RAER is your go-to destination
          for shirts that set you apart. Each piece is designed with a keen eye
          for detail, ensuring you don’t just wear a shirt—you wear confidence.
        </p>
      </div>
      <div className="row second-container-done mt-5 align-items-center">
        <div className="col-sm-12 col-md-6 align-item-center seco">
          <div className="styleimg">
            {" "}
            {/* <img src={img3} alt="" /> */}
            <img
              src="https://raerproductiondata.s3.ap-south-1.amazonaws.com/products/1722833421694_DSC01797.webp"
              alt=""
            />
          </div>
        </div>
        <div className="para col-sm-12 col-md-6  ">
          <h4 className="">Unconventional Classics</h4>
          <p id="para" className="">
            At RAER, we believe in rewriting the rules of classic menswear. Our
            shirts are crafted for those who dare to be different while
            appreciating the comfort and quality of traditional design. Whether
            you’re navigating the corporate jungle or making a mark on the
            social scene, RAER shirts are your perfect ally—versatile enough to
            transition seamlessly from day to night, bold enough to leave a
            lasting impression.
          </p>

          <p>
            {/* Our collection is a testament to versatility, allowing you to
            effortlessly transition from the corporate hustle of boardrooms to
            the laid-back charm of weekend outings. Each garment is meticulously
            designed to embody the essence of timeless style, transcending
            fleeting trends and making a lasting statement wherever life takes
            you. */}
          </p>
        </div>
      </div>
      <div className="row second-container-done mt-5 align-items-center quality ">
        <div className="col-sm-12 col-md-6 para">
          <h4 className="">Quality with an Edge</h4>
          <div>
            <p className="">
              RAER shirts are not just about looking good—they’re about feeling
              unstoppable. We select only the finest fabrics, ensuring that each
              shirt offers unmatched comfort and durability. Our designs
              challenge the mundane, with cuts and details that embody a
              rebellious spirit. When you wear RAER, you’re not just keeping up
              with trends—you’re setting them.
            </p>

            <p>
              {/* Indulge in the art of dressing well, for we believe that every age
              is the right age to present your best self to the world. Whether
              you are a young professional making your mark or a seasoned
              individual with a refined taste, Raer is your companion in the
              journey of looking and feeling your absolute best. */}
            </p>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 align-item-center seco">
          <div className="styleimg">
            <img src={img1} alt="" />
          </div>
        </div>
      </div>
      <div className="row second-container-done mt-5 align-items-center">
        <div className="col-6 align-item-center seco">
          {/* <img src={img2} alt="" className="img" /> */}
          <div className="styleimg">
            <img
              src="https://raerproductiondata.s3.ap-south-1.amazonaws.com/products/1722833365116_DSC01581.webp"
              alt=""
            />
          </div>
        </div>
        <div className="col-sm-12 col-md-6 para">
          <h4>Why RAER?</h4>
          <div>
            <p className="lastpara">
              RAER is for the man who knows that true style is about more than
              just appearance—it’s about attitude. Our shirts are designed to be
              as unique as the individuals who wear them, combining classic
              elements with unexpected twists. Choose RAER when you want to
              stand out, not blend in.
            </p>
          </div>
        </div>
      </div>
      <div className="row second-container-done mt-5 align-items-center mb-5 quality">
        <div className="col-sm-12 col-md-6 para ">
          <h4>Elevate Your Look with RAER</h4>
          <div>
            <p className="lastpara">
              Ready to make a statement? RAER shirts are more than just
              clothing—they’re an expression of who you are. Explore our
              collection, and find the perfect shirt that resonates with your
              style. With RAER, you don’t just dress—you elevate. Welcome to a
              brand that’s as rare as you are.
            </p>
          </div>
        </div>
        <div className="col-6 align-item-center seco">
          {/* <img src={img2} alt="" className="img" /> */}
          <div className="styleimg">
            <img
              src="https://raerproductiondata.s3.ap-south-1.amazonaws.com/products/1722833738171_DSC02967.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default about;
